<template>
    <UserPageLayout @login-success="setIsLoginStatus">
        <div id="nav-animate" class="flex flex-wrap max-w-3xl mx-auto">
            <div v-if="showPurchaseBlock && isShowPurchase" class="col-xl-12 text-center border-bottom-dashed pb-6">
                <div class="max-w-2xl mx-auto">
                    <div style="margin-bottom: 4rem">
                        <h1 class="system-text-color text-center text-3xl">
                            {{ isTeacher ? $t('teacher_purchase_header') : $t('purchase_header') }}
                        </h1>
                        <p v-if="!isTeacher" class="text-xl text-center system-text-color mb-6 px-3">
                            {{ $t('purchase_description') }}
                        </p>
                        <p v-if="isTeacher" class="text-xl text-center system-text-color mb-6">
                            {{
                                isTeacherPlus
                                    ? $t('teacher_purchase_description_plus')
                                    : $t('teacher_purchase_description_basic')
                            }}
                        </p>
                    </div>

                    <div class="flex flex-wrap justify-center mx-auto">
                        <div
                            v-if="subscripeSelected"
                            class="flex flex-col items-center justify-end col-xl-4 col-md-12 text-center px-3 pb-3"
                        >
                            <div class="highlight-mark">
                                <span v-if="isTeacher">
                                    <i class="fas fa-graduation-cap"></i>
                                    {{ $t('teacher_purchase_school_access_plus') }}
                                </span>
                                <span v-else>
                                    {{ $t('purchase_subscription_best_value') }}
                                </span>
                            </div>
                            <div
                                :class="{ 'disabled-plan': isLogin && !isTeacherBasic && isTeacher }"
                                class="purchase-plan-block text-dark-charcoal system-border"
                            >
                                <h1 class="text-center text-2xl shadow-text-none mb-0">
                                    {{
                                        isTeacher
                                            ? $t('teacher_purchase_subscription_plan')
                                            : $t('purchase_subscription_plan')
                                    }}
                                </h1>
                                <p
                                    class="text-lg text-center shadow-text-none mt-2 mb-6"
                                    v-html="
                                        isTeacher
                                            ? $t('teacher_purchase_subscription_plan_description')
                                            : $t('purchase_subscription_plan_description')
                                    "
                                ></p>

                                <div
                                    class="flex flex-col w-full justify-center items-center px-2 py-1 plan-title system-border-top system-border-bottom"
                                >
                                    <div class="flex">
                                        <div v-if="!isTeacher">
                                            <button
                                                @click="selectPrev('subscripePriceText', 'subscripeIndex')"
                                                :class="{
                                                    'system-primary-text-color': true,
                                                    'text-3xl payment-control-btn': true,
                                                    'cursor-pointer': !subscripeIndex == 0,
                                                    'system-primary-text-color opacity-40 cursor-not-allowed':
                                                        subscripeIndex == 0
                                                }"
                                            >
                                                <!-- <i class="fas fa-minus"></i> -->
                                                <IconMinusCircle />
                                            </button>
                                        </div>
                                        <div class="text-4xl mx-3 font-bold">
                                            <i class="fas fa-users mr-2 shadow-text-none"></i>
                                            {{ subscripeSelected.player }}
                                        </div>
                                        <div v-if="!isTeacher">
                                            <button
                                                @click="
                                                    selectNext(
                                                        'subscripePriceText',
                                                        'subscripeIndex',
                                                        'subscripePlan',
                                                        interval
                                                    )
                                                "
                                                :class="{
                                                    'system-primary-text-color': true,
                                                    'text-3xl payment-control-btn': true,
                                                    'cursor-pointer':
                                                        subscripeIndex < subscripePlan[interval].length - 1,
                                                    'system-primary-text-color opacity-40 cursor-not-allowed':
                                                        subscripeIndex == subscripePlan[interval].length - 1
                                                }"
                                            >
                                                <!-- <i class="fas fa-plus"></i> -->
                                                <IconPlusCircle />
                                            </button>
                                        </div>
                                    </div>
                                    <ul class="plan-list list-reset text-center">
                                        <li
                                            class="text-base"
                                            v-html="
                                                isTeacher
                                                    ? $t('teacher_purchase_subscription_detail')
                                                    : $t('purchase_subscription_choice_detail')
                                            "
                                        ></li>
                                    </ul>
                                </div>
                                <div
                                    class="text-3xl md:text-5xl mt-1 pb-1 mb-0 mx-0 text-center plan-title system-border-bottom"
                                >
                                    <h3
                                        v-if="!isTeacher"
                                        class="m-0 price-text text-4xl shadow-text-none"
                                        ref="subscripePriceText"
                                    >
                                        <span v-if="checkable" class="text-old-price pr-3">
                                            ${{ ((subscripeSelected.stripe.unit_amount / 100) * 2) / 12 }}
                                        </span>
                                        <!-- price month -->
                                        <span v-if="interval === 'month'">
                                            ${{ subscripeSelected.stripe.unit_amount / 100 }}
                                        </span>
                                        <!-- price year -->
                                        <span v-else>${{ subscripeSelected.stripe.unit_amount / 100 / 12 }}</span>
                                        <span class="text-lg" style="font-weight: normal">
                                            /
                                            {{
                                                interval === 'month'
                                                    ? $t('purchase_subscription_billed_month_interval')
                                                    : $t('purchase_subscription_billed_month_interval')
                                            }}
                                        </span>
                                    </h3>
                                    <!-- teacher price -->
                                    <h3 v-else class="m-0 price-text text-4xl shadow-text-none">
                                        <span v-if="subscripeSelected.currency === 'USD'"
                                            >${{ subscripeSelected.amount }}</span
                                        >
                                        <span v-else>{{ subscripeSelected.amount }}kr</span>

                                        <span class="text-lg" style="font-weight: normal">
                                            /
                                            {{
                                                interval === 'month'
                                                    ? $t('purchase_subscription_billed_month_interval')
                                                    : $t('purchase_subscription_billed_year_interval')
                                            }}
                                        </span>
                                    </h3>
                                </div>
                                <div class="footer-area py-3 px-4">
                                    <div class="flex items-center">
                                        <XToggleSwitch
                                            @input="fetchSubscriptionPlan()"
                                            :checked="checkable"
                                            :show-background="true"
                                            :show-toggle-symbol="false"
                                            color="var(--ui-primary-color-alpha-40)"
                                            border-color="var(--ui-primary-color)"
                                            checked-color="var(--ui-primary-color)"
                                            height="22"
                                        />
                                        <span v-if="!isTeacher" class="pl-2 text-sm shadow-text-none">
                                            ${{
                                                !checkable
                                                    ? ((subscripeSelected.stripe.unit_amount / 100) * 12) / 2
                                                    : subscripeSelected.stripe.unit_amount / 100
                                            }}
                                            {{ $t('purchase_subscription_billed_yearly') }}
                                        </span>
                                        <span v-else class="pl-2 text-sm shadow-text-none">
                                            {{ $t('purchase_subscription_billed_yearly') }}
                                        </span>
                                    </div>
                                    <div class="offer-box">
                                        <div v-if="!checkable" class="flex justify-center items-baseline pr-10">
                                            <ArrowDiscount />
                                            <span class="pl-4 font-bold text-2xl shadow-text-none">
                                                {{ $t('purchase_subscription_discount') }} 50%
                                            </span>
                                        </div>
                                        <div v-else class="flex justify-center items-baseline">
                                            <span class="font-bold text-2xl shadow-text-none">
                                                {{ $t('purchase_subscription_got_discount') }} 50%
                                            </span>
                                        </div>
                                        <div class="font-semibold shadow-text-none">
                                            {{ $t('purchase_subscription_ai_description') }}
                                        </div>
                                    </div>

                                    <div class="flex flex-col">
                                        <!-- hidden button -->
                                        <button
                                            v-if="geoLocation && geoLocation.code == 'NO'"
                                            @click="setVippsModal('access', subscripeSelected, true)"
                                            class="btn btn-outline btn-vipps w-full font-opensans font-size-15 mb-1 mt-4"
                                            style="padding: 0.7rem 0"
                                            type="button"
                                        >
                                            {{ $t('purchase_button_vipps') }}
                                        </button>
                                        <form @submit.prevent="subscribeByPaypal" :action="agreementUrl" method="post">
                                            <input name="id" :value="subscripeSelected.id" type="hidden" />
                                            <input name="plan_id" :value="subscripeSelected.plan_id" type="hidden" />
                                            <div class="relative">
                                                <div
                                                    v-if="
                                                        couponCode &&
                                                        interval === 'year' &&
                                                        couponContent &&
                                                        couponContent.discount
                                                    "
                                                    class="discount animated pulse infinite"
                                                >
                                                    -{{ couponContent.discount
                                                    }}{{ couponContent.currency ? ' USD' : '%' }}
                                                </div>
                                                <button
                                                    @click="
                                                        subscribeByStripe(
                                                            'stripe' + subscripeIndex,
                                                            subscripeSelected.stripe
                                                        )
                                                    "
                                                    :disabled="
                                                        couponCode &&
                                                        interval === 'year' &&
                                                        couponContent &&
                                                        couponContent.discount &&
                                                        (subscripeSelected.amount ||
                                                            subscripeSelected.stripe.unit_amount / 100) -
                                                            discountSubscription <
                                                            1
                                                    "
                                                    class="btn btn-outline btn-stripe w-full font-opensans font-size-15 mb-1 relative"
                                                    style="padding: 0.7rem 0"
                                                    type="button"
                                                >
                                                    {{ $t('purchase_button_stripe') }}
                                                </button>
                                            </div>
                                            <button
                                                class="btn btn-block btn-paypal text-sm font-opensans mb-1 flex justify-center items-center"
                                            >
                                                <PaypalLogo></PaypalLogo>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="accessSelected && !isTeacher"
                            class="flex flex-col items-center justify-end col-xl-4 col-md-12 text-center px-3 pb-3"
                        >
                            <div class="highlight-mark invisible"></div>
                            <div class="purchase-plan-block text-dark-charcoal system-border">
                                <h1 class="text-center text-2xl shadow-text-none mb-0">
                                    {{ $t('purchase_header_24hour') }}
                                </h1>
                                <p
                                    class="text-lg text-center shadow-text-none mt-2 mb-6"
                                    v-html="$t('purchase_24hour_description')"
                                ></p>
                                <div
                                    class="flex flex-col w-full justify-center items-center px-2 py-1 plan-title system-border-top system-border-bottom"
                                >
                                    <div class="flex">
                                        <div>
                                            <button
                                                @click="selectPrev('accessPriceText', 'accessIndex')"
                                                :class="{
                                                    'system-primary-text-color': true,
                                                    'text-3xl payment-control-btn': true,
                                                    'cursor-pointer': !accessIndex == 0,
                                                    'system-primary-text-color opacity-40 cursor-not-allowed':
                                                        accessIndex == 0
                                                }"
                                            >
                                                <!-- <i class="fas fa-minus"></i> -->
                                                <IconMinusCircle />
                                            </button>
                                        </div>
                                        <div class="text-4xl mx-3 font-bold">
                                            <i class="fas fa-users mr-2 shadow-text-none"></i>
                                            {{ accessSelected.limitPlayer }}
                                        </div>
                                        <div>
                                            <button
                                                @click="selectNext('accessPriceText', 'accessIndex', 'accessPlan')"
                                                :class="{
                                                    'system-primary-text-color': true,
                                                    'text-3xl payment-control-btn': true,
                                                    'cursor-pointer': accessIndex < accessPlan.length - 1,
                                                    'system-primary-text-color opacity-40 cursor-not-allowed':
                                                        accessIndex == accessPlan.length - 1
                                                }"
                                            >
                                                <!-- <i class="fas fa-plus"></i> -->
                                                <IconPlusCircle />
                                            </button>
                                        </div>
                                    </div>
                                    <ul class="plan-list list-reset text-center">
                                        <li
                                            v-html="$t('purchase_24hour_number_player_description')"
                                            class="text-base"
                                        ></li>
                                    </ul>
                                </div>
                                <div
                                    class="text-3xl md:text-5xl mt-1 pb-1 mb-0 mx-0 text-center plan-title system-border-bottom"
                                >
                                    <h3 class="m-0 price-text text-4xl shadow-text-none" ref="accessPriceText">
                                        ${{ accessSelected.price }}
                                        <span class="text-lg" style="font-weight: normal">
                                            / {{ $t('purchase_24hour_hour') }}
                                        </span>
                                    </h3>
                                </div>
                                <div class="footer-area py-3 px-4">
                                    <div class="flex"></div>
                                    <div class="flex flex-col">
                                        <button
                                            v-if="isLogin"
                                            @click="paidByCredit"
                                            :disabled="accessSelected.price > userCredits"
                                            class="btn btn-outline credit-btn w-full font-opensans font-size-15 mt-1 mb-1"
                                            style="border: 1px solid transparent; border-radius: 5px; box-shadow: none"
                                            type="button"
                                        >
                                            <span class="block shadow-text-none">
                                                {{ $t('purchase_button_credit') }}
                                            </span>
                                            <span class="block shadow-text-none font-thin font-size-11">
                                                {{
                                                    $t('purchase_24hour_user_credit', {
                                                        userCredits: userCredits,
                                                        s: userCredits > 1 ? 's' : ''
                                                    })
                                                }}
                                            </span>
                                        </button>
                                        <button
                                            v-if="geoLocation && geoLocation.code == 'NO'"
                                            @click="setVippsModal('access', accessSelected)"
                                            class="btn btn-outline btn-vipps w-full font-opensans font-size-15 mb-1"
                                            style="padding: 0.7rem 0"
                                            type="button"
                                        >
                                            {{ $t('purchase_button_vipps') }}
                                        </button>
                                        <button
                                            @click="setStripeModal(true, accessSelected, '24-hour')"
                                            class="btn btn-outline btn-stripe w-full font-opensans font-size-15 mb-1 relative"
                                            style="padding: 0.7rem 0"
                                            type="button"
                                        >
                                            {{ $t('purchase_button_stripe') }}
                                        </button>
                                        <div v-if="isLogin != null" class="paypal-button-wrapper">
                                            <PaypalButton
                                                v-if="isLogin"
                                                @success="paidByPaypal"
                                                @creating="toggleLoading(true)"
                                                @cancel="toggleLoading(false)"
                                                @error="toggleLoading(false)"
                                                :track="'access'"
                                                :price="accessSelected.price"
                                            />
                                            <button
                                                v-else
                                                class="btn btn-block btn-paypal text-sm font-opensans flex justify-center items-center"
                                                @click="openAuthPopup"
                                            >
                                                <PaypalLogo></PaypalLogo>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-html="footerDescription" class="text-lg text-center system-text-color mt-3 px-3"></p>
                </div>
            </div>
            <div class="col-xl-12 text-center">
                <div class="max-w-2xl mx-auto">
                    <div style="margin-bottom: 3rem">
                        <h1 class="system-text-color text-center text-3xl">
                            {{ $t('purchase_header_premium_features') }}
                        </h1>
                    </div>
                </div>
                <div class="flex flex-wrap mx-auto" style="margin-bottom: 6rem">
                    <div
                        v-for="(feature, featureIndex) in premiumFeatures"
                        :key="featureIndex"
                        :class="{
                            'flex-col items-center col-xl-4 col-md-12 text-center p-3': true,
                            flex: feature.show_in_package.includes(interval),
                            hidden: !feature.show_in_package.includes(interval)
                        }"
                    >
                        <div class="purchase-plan-block text-dark-charcoal system-border max-w-premium">
                            <h1 class="plan-block-title text-center text-2xl shadow-text-none">{{ feature.title }}</h1>
                            <div
                                class="plan-block-image"
                                :style="{ backgroundImage: `url(${getFeatureImage(feature.images)})` }"
                            ></div>
                            <div class="plan-block-qoutes" :class="{ 'none-padding': feature.bullet }">
                                <ul v-if="feature.bullet">
                                    <li :key="index" v-for="(text, index) in feature.texts" class="text-left">
                                        {{ text }}
                                    </li>
                                </ul>
                                <div v-else class="long-text text-left">{{ feature.texts.join(' ') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <StripeCheckout
            @result="paidByStripe"
            @close="setStripeModal"
            :open="stripeTag.status"
            :title="stripeTag.item ? stripeTag.item.title : ''"
            :campaign-id="couponContent && typeof couponContent != 'undefined' ? couponContent.id : ''"
            :coupon-code="couponContent && typeof couponContent != 'undefined' ? couponContent.code : ''"
            :perUnit="stripeTag.item ? stripeTag.item.unit : ''"
            :paymentDescription="stripeTag.item ? stripeTag.item.description : ''"
            :amount="stripeTag.item ? stripeTag.item.price : 0"
        />
        <Vipps
            @result="paidByVipps"
            @close="resetVipps"
            @subscription="onSubscription"
            :open="vippsData.status"
            :amount="vippsData.item ? vippsData.item.amount : 0"
            :title="vippsData.item ? vippsData.item.title : ''"
            :unit="vippsData.item ? vippsData.item.unit : ''"
            :unitText="vippsData.item ? vippsData.item.unit_text : ''"
            :is-subscription="isSubscriptionVipps"
            :vipps-data="vippsData"
        />
        <CouponModal
            v-if="showCouponModal"
            @use="useCoupon"
            @coupon="onCoupon"
            @close="showCouponModal = false"
            :content="couponContent"
            ref="couponModal"
        />
    </UserPageLayout>
</template>

<script>
import UserPageLayout from '@/layouts/UserPage'
import Request from '@/lib/request'
import appConfig from '@/app.config'
import UserService from '@/lib/user'
import PaypalButton from '@/components/PaypalButton'
import StripeCheckout from '@/components/StripeCheckout'
import { loadStripe } from '@stripe/stripe-js'
import { currentUser, getToken } from '@/lib/user'
import randomize from 'randomatic'
import popup from '@/lib/popup'
import { mapGetters } from 'vuex'
import datalist from '@/mixins/datalist'
import Vipps from '@/components/VippsPayment'
import helper from '@/lib/helper.js'
import CouponModal from '@/components/CouponModal'
import PaypalLogo from '@/components/PaypalLogo'
import XToggleSwitch from '@/components/v2/XToggleSwitch'
import ArrowDiscount from '../components/ArrowDiscount'
import IconPlusCircle from '../components/IconPlusCircle'
import IconMinusCircle from '../components/IconMinusCircle'
var CustomEvent = require('custom-event')

export default {
    metaInfo() {
        return {
            title: this.$t('title_purchase_plans')
        }
    },

    mixins: [datalist],

    components: {
        Vipps,
        UserPageLayout,
        PaypalButton,
        StripeCheckout,
        CouponModal,
        PaypalLogo,
        XToggleSwitch,
        ArrowDiscount,
        IconPlusCircle,
        IconMinusCircle
    },

    async created() {
        const userService = new UserService()
        this.setIsLoginStatus(userService.isLoggedIn())

        if (userService.isLoggedIn()) {
            const couponStatus = await this.checkCouponStatus()
            if (couponStatus) {
                this.showCouponModal = true
            }
        }
    },

    mounted() {
        this.$store.commit('updateRemoveAppPaddingX', true)

        this.fetchSubscriptionPlan(true)
        document.body.style.overflow = 'auto'
        this.$store.dispatch('getCurrentCountry').then(res => {
            this.geoLocation = res.data.data
        })

        if (this.isTeacher) {
            document.addEventListener('click', event => {
                if (event.target.classList.contains('link-school')) {
                    event.preventDefault()

                    if (this.isSkolerPage() || (currentUser() && currentUser().provider === 'feide')) {
                        window.open(process.env.VUE_APP_NUXT_BASE_URL + '/skoler?upgrade=true', '_blank')
                        return
                    }

                    window.open(process.env.VUE_APP_NUXT_BASE_URL + '/school?upgrade=true', '_blank')
                }
            })
        }
    },

    computed: {
        ...mapGetters({
            userCredits: 'getUserCredit',
            couponCode: 'getCouponCode',
            orderAbility: 'orderAbility'
        }),

        agreementUrl() {
            return `${appConfig.baseUrl}plans/agreement`
        },

        subscripeSelected() {
            if (this.subscripePlan[this.interval].length > 0) {
                this.onDiscount(this.subscripePlan[this.interval][this.subscripeIndex].amount, 'subscription')
                return this.subscripePlan[this.interval][this.subscripeIndex]
            }
            return null
        },

        creditSelected() {
            if (this.creditPlan.length > 0) {
                this.onDiscount(this.creditPlan[this.creditIndex].price, 'pay-as-you-go')
                return this.creditPlan[this.creditIndex]
            }
            return null
        },

        accessSelected() {
            if (this.accessPlan.length > 0) {
                this.onDiscount(this.accessPlan[this.accessIndex].price, '24-hour')
                return this.accessPlan[this.accessIndex]
            }
            return null
        },

        isTeacher() {
            return (
                (this.isLogin && currentUser().role.includes('teacher')) ||
                ['skoler-purchase', 'school-purchase'].includes(this.$router.currentRoute.name)
            )
        },

        showPurchaseBlock() {
            const role = currentUser().role || ''

            return role.includes('student') === false
        },

        isTeacherBasic() {
            return this.isLogin && currentUser().role === 'teacher'
        },

        isTeacherPlus() {
            return this.isLogin && currentUser().role === 'teacher_plus'
        },

        footerDescription() {
            if (!this.isLogin) {
                if (['skoler-purchase', 'school-purchase'].includes(this.$router.currentRoute.name)) {
                    return this.$t('teacher_purchase_buy_access_school')
                }

                return this.$t('purchase_description2')
            }

            if (this.isTeacherBasic) {
                return this.$t('teacher_purchase_buy_access_school')
            }

            if (this.isTeacherPlus) {
                return ''
            }

            return ['skoler-purchase', 'school-purchase'].includes(this.$router.currentRoute.name)
                ? this.$t('teacher_purchase_buy_access_school')
                : this.$t('purchase_description2')
        }
    },

    data() {
        return {
            checkable: true,
            publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
            subscripePlan: {
                month: [],
                year: []
            },
            creditPlan: appConfig.buyCreditPlan,
            accessPlan: appConfig.payPlayerPlans,
            subscripeIndex: 0,
            creditIndex: 0,
            accessIndex: 0,
            isLogin: null,
            interval: 'year',
            geoLocation: null,
            stripeTag: {
                status: false,
                item: null
            },
            vippsData: {
                status: false,
                item: null
            },
            showCouponModal: false,
            couponId: null,
            isDisabled: false,
            discountSubscription: 1,
            discountPayAsYouGo: 1,
            couponContent: null,
            isSubscriptionVipps: false,
            isShowPurchase: true
        }
    },

    methods: {
        onSubscription(type) {
            this.isSubscriptionVipps = type
        },

        onDiscount(price, type) {
            if (this.couponCode && this.couponContent && typeof this.couponContent != 'undefined') {
                if (this.couponContent.currency) {
                    if (type == 'subscription') {
                        this.discountSubscription = this.couponContent.discount
                    } else if (type == 'pay-as-you-go') {
                        this.discountPayAsYouGo = this.couponContent.discount
                    }
                } else {
                    if (type == 'subscription') {
                        this.discountSubscription = (this.couponContent.discount * price) / 100
                    } else if (type == 'pay-as-you-go') {
                        this.discountPayAsYouGo = (this.couponContent.discount * price) / 100
                    }
                }
            }
        },

        fetchSubscriptionPlan(firstLoad = null) {
            let interval = this.interval

            if (!firstLoad) {
                interval = this.interval === 'month' ? 'year' : 'month'
            }
            const condition = {
                recurring: {
                    interval: interval
                }
            }

            if (this.isTeacher) {
                condition.school_plan = 1
            }

            if (this.subscripePlan[condition.recurring.interval].length == 0) {
                const request = new Request()

                this.toggleLoading(true)

                const headers = this.isLogin
                    ? {
                          Authorization: `Bearer ${getToken()}`
                      }
                    : {}

                request
                    .post(appConfig.api.getSubscriptionPlan, condition, {
                        headers
                    })
                    .then(res => {
                        this.subscripePlan[condition.recurring.interval] = res.data.data
                        this.interval = interval
                        this.checkable = interval === 'year'
                        this.toggleLoading(false)
                    })
                    .catch(() => {
                        this.toggleLoading(false)
                    })
            } else {
                this.interval = interval
                this.checkable = interval === 'year'
            }
        },

        resetVipps(onlyclose = false) {
            this.toggleLoading(false)

            if (onlyclose) {
                this.vippsData.status = false
                return
            }

            this.vippsData = {
                status: false,
                item: null
            }
        },

        setIsLoginStatus(status) {
            this.isLogin = status

            if (currentUser() && currentUser().role.includes('student')) {
                this.isShowPurchase = false
            }
        },

        setVippsModal(target, data, isSubscription = false) {
            if (this.isTeacherPlus) {
                return
            }

            this.checkAuthUser().then(() => {
                if (this.isTeacher && !this.isSchoolRoles) {
                    this.toggleLoading(false)
                    popup.alert(this.$t('purchase_alert_permission'), function () {}, { icon: 'error' })
                    return
                }

                var payload = {
                    amount: !isSubscription ? data.priceKr : data.nok_amount
                }

                if (target == 'access') {
                    if (isSubscription) {
                        payload['title'] = this.$t('vipps_modal_description', { limitPlayer: data.player })
                        payload['interval'] = {
                            unit: this.interval.toUpperCase(),
                            count: 1
                        }
                        payload['limitPlayer'] = data.player
                        payload['payment_on'] = 'access'
                        payload['plan_id'] = data.plan_id
                    } else {
                        payload['title'] = this.$t('vipps_modal_description', { limitPlayer: data.limitPlayer })
                        payload['unit'] = '24 hours'
                        payload['unit_text'] = this.$t('vipps_modal_unit_24hour')
                        payload['payment_on'] = 'access'
                    }
                }

                if (target == 'credit') {
                    payload['title'] = ''
                    payload['unit'] = `${data.credit} credit(s)`
                    payload['unit_text'] = this.$t('vipps_modal_unit_pay_as_you_go', {
                        credit: data.credit,
                        s: data.credit > 1 ? 's' : ''
                    })
                    payload['payment_on'] = 'credit'
                }

                this.isSubscriptionVipps = isSubscription

                this.vippsData = {
                    status: true,
                    item: payload
                }

                this.toggleLoading(false)
            })
        },

        setStripeModal(status = false, target = null, type = null) {
            const data = {
                status: status,
                target: target
            }

            this.checkAuthUser().then(() => {
                this.toggleLoading(false)
                if (data.target) {
                    let price = data.target.price

                    if (this.couponCode && this.couponContent && typeof this.couponContent != 'undefined') {
                        if (this.couponContent.discount) {
                            if (this.couponContent.currency) {
                                price = parseInt(data.target.price) - parseInt(this.couponContent.discount)
                            } else {
                                let discount = 0

                                if (type == 'subscription') {
                                    discount = this.discountSubscription
                                } else if (type == 'pay-as-you-go') {
                                    discount = this.discountPayAsYouGo
                                }

                                price =
                                    type == '24-hour'
                                        ? data.target.price
                                        : parseFloat(data.target.price - discount).toFixed(2)
                            }
                        }
                    }

                    var payload = { price: price }

                    if (data.target.credit != undefined) {
                        payload['title'] = ''
                        payload['unit'] = this.$t('stripe_modal_unit_pay_as_you_go', {
                            credit: data.target.credit,
                            s: data.target.credit > 1 ? 's' : ''
                        })
                        payload['description'] = 'Buy credit'
                        payload['payment_on'] = 'credit'
                    }

                    if (data.target.limitPlayer != undefined) {
                        payload['title'] = this.$t('stripe_modal_description', { limitPlayer: data.target.limitPlayer })
                        payload['unit'] = this.$t('stripe_modal_unit_24hour')
                        payload['description'] = 'Upgrade players'
                        payload['payment_on'] = 'access'
                    }
                }

                this.stripeTag = {
                    status: data.status,
                    item: payload
                }
            })
        },

        checkAuthUser() {
            const userService = new UserService()
            this.toggleLoading(true)

            return new Promise((resolve, reject) => {
                userService
                    .validateToken()
                    .then(() => {
                        resolve()
                    })
                    .catch(() => {
                        this.openAuthPopup()
                        reject()
                    })
            })
        },

        openAuthPopup() {
            this.toggleLoading(false)

            if (this.isSkolerPage()) {
                this.$store.commit('setShowFeideLogin', true)
                return
            }

            window.dispatchEvent(new CustomEvent('auth-show'))
        },

        selectNext(refName, attribute, attribute2, subattribute2 = null) {
            var target = this[attribute2]

            if (subattribute2) {
                target = target[subattribute2]
            }

            if (this[attribute] + 1 >= target.length) {
                return
            }

            this.animatePrice(refName)
            this[attribute]++
        },

        selectPrev(refName, attribute) {
            if (this[attribute] <= 0) {
                return
            }

            this.animatePrice(refName)
            this[attribute]--
        },

        subscribeByStripe(refKey, payload) {
            if (this.isTeacherPlus) {
                return
            }

            this.checkAuthUser().then(() => {
                if (this.isTeacher && !this.isSchoolRoles) {
                    this.toggleLoading(false)
                    popup.alert(this.$t('purchase_alert_permission'), function () {}, { icon: 'error' })
                    return
                }

                const request = new Request()

                var plan = payload
                plan['user_id'] = currentUser().id
                plan['track'] = randomize('A0', 17)

                if (this.couponContent && this.interval == 'year') {
                    plan['coupon_id'] = this.couponId ? this.couponId : ''
                    plan['coupon_code'] = typeof this.couponContent.code != 'undefined' ? this.couponContent.code : ''
                    plan['campaign_id'] = typeof this.couponContent.id != 'undefined' ? this.couponContent.id : ''
                } else {
                    plan['coupon_id'] = ''
                    plan['coupon_code'] = ''
                    plan['campaign_id'] = ''
                }

                request.post(appConfig.api.stripeCreateSession, payload).then(res => {
                    if (res.data.message == 'create_session_success') {
                        const session = res.data.data

                        Promise.resolve(loadStripe(this.publicKey)).then(stripe => {
                            stripe.redirectToCheckout({
                                sessionId: session.id
                            })
                        })
                    }
                })
            })
        },

        subscribeByPaypal(e) {
            if (this.isTeacherPlus) {
                return
            }

            this.checkAuthUser().then(() => {
                if (this.isTeacher && !this.isSchoolRoles) {
                    this.toggleLoading(false)
                    popup.alert(this.$t('purchase_alert_permission'), function () {}, { icon: 'error' })
                    return
                }

                e.target.submit()
            })
        },

        paidByCredit() {
            this.toggleLoading(true)
            const selected = this.accessPlan[this.accessIndex]

            const payload = {
                order_id: randomize('A0', 17),
                payer_name: currentUser().name,
                payer_email: currentUser().email,
                payer_id: currentUser().id,
                amount: parseFloat(selected.price).toFixed(2),
                user_id: currentUser().id,
                method: 'credit',
                data: {
                    limit_player: selected.limitPlayer
                },
                quiz_id: 0
            }

            if (this.accessSelected.price <= this.userCredits) {
                const request = new Request()

                request
                    .post(appConfig.api.saveBuyPlayerOrder, payload)
                    .then(() => {
                        popup.alert(this.$t('purchase_alert_success'), function () {}, { icon: 'success' })
                        this.toggleLoading(false)
                        this.$store.dispatch('getCredit')
                    })
                    .catch(() => {
                        this.toggleLoading(false)
                        popup.alert(this.$t('purchase_alert_fail'), function () {}, { icon: 'error' })
                    })
            }
        },

        paidByVipps(status) {
            if (status == 'RESERVE') {
                var trackType = '24hrs_access'

                if (this.vippsData.item && this.vippsData.item.payment_on == 'credit') {
                    trackType = 'credit'
                    this.$store.dispatch('getCredit')
                }

                this.trackPay('vipps', trackType)

                popup.alert(this.$t('purchase_alert_success'), function () {}, { icon: 'success' })
            } else {
                popup.alert(this.$t('purchase_alert_fail'), function () {}, { icon: 'error' })
            }

            this.creditIndex = 0
            this.accessIndex = 0
            this.resetVipps()
        },

        paidByStripe(res) {
            if (res.status_code == 200) {
                var payload = {
                    order_id: res.data.id,
                    payer_name: currentUser().name,
                    payer_email: currentUser().email,
                    payer_id: currentUser().id,
                    user_id: currentUser().id,
                    amount: parseFloat(res.data.amount / 100).toFixed(2),
                    method: res.data.method,
                    quiz_id: 0,
                    campaign_id: res.campaign_id
                }

                if (this.stripeTag.item.payment_on == 'credit') {
                    const selected = this.creditPlan[this.creditIndex]
                    payload['credits'] = parseFloat(selected.credit).toFixed(2)
                    payload['type'] = 'buy-credit'
                }

                if (this.stripeTag.item.payment_on == 'access') {
                    const selected = this.accessPlan[this.accessIndex]
                    payload['data'] = { limit_player: selected.limitPlayer }
                }

                const request = new Request()

                request
                    .post(appConfig.api.saveBuyPlayerOrder, payload)
                    .then(() => {
                        var trackType = 'credit'

                        if (this.stripeTag.item.payment_on == 'credit') {
                            this.$store.dispatch('getCredit')
                            this.creditIndex = 0
                        }

                        if (this.stripeTag.item.payment_on == 'access') {
                            this.accessIndex = 0
                            trackType = '24hrs_access'
                        }

                        this.setStripeModal()
                        this.trackPay('stripe', trackType)

                        popup.alert(
                            this.$t('purchase_alert_success'),
                            () => {
                                this.$router.go(0)
                            },
                            { icon: 'success' }
                        )
                    })
                    .catch(() => {
                        this.setStripeModal()
                        popup.alert(this.$t('purchase_alert_fail'), function () {}, { icon: 'error' })
                    })
            } else {
                this.setStripeModal()
                popup.alert(res.message, function () {}, { icon: 'error' })
            }
        },

        paidByPaypal(details) {
            const payload = {
                order_id: details.id,
                payer_name: `${details.payer.name.given_name} ${details.payer.name.surname}`,
                payer_email: details.payer.email_address,
                payer_id: details.payer.payer_id,
                user_id: currentUser().id,
                method: 'paypal',
                quiz_id: 0
            }

            var trackType = 'credit'

            if (details.track == 'credit') {
                const selected = this.creditPlan[this.creditIndex]
                payload['amount'] = parseFloat(selected.credit).toFixed(2)
                payload['type'] = 'buy-credit'
            }

            if (details.track == 'access') {
                const selected = this.accessPlan[this.accessIndex]
                payload['amount'] = details.purchase_units[0].amount.value
                payload['data'] = { limit_player: selected.limitPlayer }
                trackType = '24hrs_access'
            }

            const request = new Request()

            request
                .post(appConfig.api.saveBuyPlayerOrder, payload)
                .then(() => {
                    this.$store.dispatch('getCredit')
                    this.toggleLoading(false)
                    this.$emit('close')
                    this.$emit('success', payload)
                    this.trackPay('paypal', trackType)
                    popup.alert(this.$t('purchase_alert_success'), function () {}, { icon: 'success' })
                })
                .catch(() => {
                    this.toggleLoading(false)
                    this.$emit('close')
                    popup.alert(this.$t('purchase_alert_fail'), function () {}, { icon: 'error' })
                })
        },

        animatePrice(refName) {
            this.$refs[refName].style.transform = 'scale(1.5)'
            setTimeout(() => {
                this.$refs[refName].style.transform = 'scale(1)'
            }, 400)
        },

        toggleLoading(status) {
            this.$store.commit('toggleMainLoader', status)
        },

        getFeatureImage(name) {
            if (!name) {
                return null
            }

            return require('@/assets/images/feature-thumbnails/' + name)
        },

        trackPay(payment, label) {
            helper.gTrackEvent('payed', {
                event_category: `Payed_${payment}`,
                event_label: `Pay_${label}_at_purchase`
            })
        },

        async checkCouponStatus() {
            const url = new URL(window.location.href)
            const couponCode = url.searchParams.get('coupon')
            this.isDisabled = false

            if (couponCode) {
                const payload = {
                    code: couponCode,
                    locale: this.$i18n.locale
                }

                const couponStatus = await this.$store.dispatch('getCouponStatus', payload)
                if (couponStatus.status === 200) {
                    const couponData = couponStatus.data.data
                    if (couponData.status === false) {
                        this.couponContent = couponData.content
                        this.isDisabled = true

                        return true
                    }
                }
            }

            return false
        },

        useCoupon(code) {
            this.interval = 'year'
            this.fetchSubscriptionPlan()
            this.$store.commit('setCoupon', code)
            this.isDisabled = true
        },

        onCoupon(id) {
            this.couponId = id
        }
    }
}
</script>

<style lang="scss">
$input-border-color: #cbcbcb;
$input-border-darker-color: #b6b6b6;

.purchase-plan-block {
    // border: 1px solid $input-border-color;
    // color: var(--ui-secondary-color);
    background-color: #fff;
    border-radius: 5px;
    transition: all 0.3s ease;
    min-height: 25rem;
    height: 100%;
    max-width: 375px;
    width: 100%;

    &.max-w-premium {
        max-width: 410px;
    }

    &.border-none {
        border: 0;
    }

    .plan-block-title {
        padding: 0 3rem;
        min-height: 65px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .plan-block-image {
        width: 100%;
        height: 10rem;
        background-color: black;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .plan-block-qoutes {
        min-height: 5rem;

        &:not(.none-padding) {
            padding: 0.9rem 1.15rem;
        }
    }

    .plan-price {
        font-size: 2.3rem;
        margin: 0 0 0.5rem 0;
    }

    .price-text {
        transition: all 0.3s ease;
    }

    .plan-title {
        border-bottom: 1px solid $input-border-darker-color;
    }

    .payment-control-btn {
        background-color: transparent;
        border: none;
        padding: 0.5rem 1rem;
        border-radius: 5px;
    }

    .btn-stripe {
        background-color: #6772e5 !important;
        border: 1px solid transparent;
        border-radius: 4px;
        box-shadow: none;
        padding-left: 0;
        padding-right: 0;

        &:hover {
            opacity: 0.8;
        }

        &:disabled {
            cursor: not-allowed;
        }
    }

    .btn-paypal {
        font-size: 1.4rem;
        padding: 0.45rem 0px;
        border-radius: 4px;
        height: 45px;
    }

    .btn-vipps {
        background-color: #ff6a21 !important;
        border: 1px solid transparent;
        border-radius: 4px;
        box-shadow: none;
        padding-left: 0;
        padding-right: 0;

        &:hover {
            opacity: 0.8;
        }
    }

    .text-old-price {
        display: inline-block;
        text-decoration: line-through;
        text-decoration-color: #f61811;
        text-decoration-thickness: 4px;
    }

    .footer-area {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 18rem;

        .offer-box {
            color: #3e9d03;
        }
    }

    .opacity-40 {
        opacity: 0.4;
    }

    &.disabled-plan {
        filter: blur(3px);
        user-select: none;
        pointer-events: none;
    }
}

.discount {
    z-index: 1;
    color: #fff;
    font-weight: bolder;
}

.highlight-mark {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    font-weight: bold;
    max-width: 320px;
    width: 80%;
    height: 2.6rem;
    background-color: rgba(255, 194, 49, 1);
    border-radius: 0.5rem 0.5rem 0 0;
}

.become-contributor-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
}

.border-bottom-dashed {
    border-bottom: 3px dashed var(--ui-primary-color);
}

.discount {
    position: absolute;
    padding: 0.3rem 0.5rem;
    background-color: red;
    border-radius: 4px;
    top: -15px;
    right: 8px;
}

#nav-animate input[type='radio' i] {
    width: 1.2rem;
    height: 1.05rem;
}

@for $i from 1 to 13 {
    .col-xl-#{$i} {
        width: calc(100% * (#{$i}/ 12));
    }
}

@media screen and (max-width: 1107px) {
    .become-contributor-content {
        justify-content: flex-start;
    }
}

@media screen and (max-width: 768px) {
    @for $i from 1 to 13 {
        .col-md-#{$i} {
            width: calc(100% * (#{$i}/ 12));
        }

        .purchase-plan-block {
            margin-bottom: 0.5rem;
        }
    }
}

@media screen and (max-width: 280px) {
    .purchase-plan-block .plan-block-title {
        padding: 0;
    }
}

@media screen and (max-width: 1098px) and (min-width: 769px) {
    .purchase-plan-block .plan-block-title {
        font-size: 1rem;
    }

    .plan-block-qoutes {
        font-size: 0.9rem;
    }
}
</style>
